import React, {useEffect, useState} from "react";
import Form, {SimpleItem} from "devextreme-react/form";
import {DropDownBox} from "devextreme-react";
import {FilterRow, Paging, Scrolling, Selection} from "devextreme-react/data-grid";
import {DevGrid} from "../index";
import Request from "../../api/Request";

const DevSimpleDropBox = (props) => {

    const [ulkeListe, setUlkeListe] = useState([]);

    useEffect(() => {

    }, [])

    const listeYukle = () => {
        const requestUlke = new Request("/ulke/getKayitList", "GET");
        requestUlke.run()
            .then(response => {
                if (response.data && response.data.data) {
                    setUlkeListe(response.data.data);
                }
            });
    }

    function dataGridRender() {
        return (
            <DevGrid
                dataSource={ulkeListe}
                columns={['kodu', 'adi']}
                hoverStateEnabled={true}
                selectedRowKeys={[1,2,3]}
                //onSelectionChanged={this.dataGrid_onSelectionChanged}
                height="100%">
                <Selection mode="single" />
                <Scrolling mode="infinite" />
                <Paging enabled={true} pageSize={10} />
                <FilterRow visible={true} />
            </DevGrid>
        );
    }


    function renderUlke() {
        return <DropDownBox
            value={"Türkiye"}
            valueExpr="ID"
            deferRendering={false}
            displayExpr={"adi"}
            placeholder="Select a value..."
            showClearButton={true}
            dataSource={props.data}
            //onValueChanged={this.syncDataGridSelection}
            contentRender={dataGridRender}
        />
    }

    return  <SimpleItem  dataField="ulke.id"  render={renderUlke}  />

}

export default DevSimpleDropBox;
